import { GlobeEuropeAfricaIcon, ArrowTrendingUpIcon, HandThumbUpIcon, BookOpenIcon, ChatBubbleOvalLeftEllipsisIcon, DocumentTextIcon, ClipboardIcon, ClockIcon, InformationCircleIcon, BriefcaseIcon, BuildingOfficeIcon, UserGroupIcon, UserIcon, ClipboardDocumentListIcon, BoltIcon, MapPinIcon, ArrowLongRightIcon, BookmarkIcon, ChatBubbleLeftRightIcon, LockClosedIcon, ShieldCheckIcon, HandRaisedIcon, MagnifyingGlassIcon, ClipboardDocumentCheckIcon, ClipboardDocumentIcon, ExclamationCircleIcon, ArrowLeftIcon, HomeIcon, HeartIcon, BellIcon, UsersIcon, BuildingOffice2Icon, PhoneIcon, EnvelopeIcon, TrashIcon, DevicePhoneMobileIcon, CheckCircleIcon as CheckCircleIconOutline } from '@heroicons/react/24/outline';
import { InformationCircleIcon as InformationCircleSolidIcon, ChartBarIcon, CalendarIcon, CheckCircleIcon } from '@heroicons/react/24/solid';
import { ApplyMoreFiltersIcon, BulbIcon, ClipIcon, CopyIcon, getAssetSrc, HouseCheckIcon, NOfficeBuildingIcon, NoLocationMarkerIcon, PrivateModeProtectionCircleIcon, PrivateModeProtectionIcon } from '@restworld/utils-common';
import { RestartIcon, LocationMarkIcon } from './svg';
import { jsx as _jsx } from "react/jsx-runtime";
// --> constants
export var titleIconMap = {
  ApplyMoreFiltersIcon: /*#__PURE__*/_jsx(ApplyMoreFiltersIcon, {
    stroke: "#1C1327"
  }),
  ArrowLeftIcon: /*#__PURE__*/_jsx(ArrowLeftIcon, {
    className: "h-5 w-5 text-black"
  }),
  ArrowLeftWhiteIcon: /*#__PURE__*/_jsx(ArrowLeftIcon, {
    className: "h-5 w-5 text-white"
  }),
  ArrowLongRightIcon: /*#__PURE__*/_jsx(ArrowLongRightIcon, {
    className: "h-5 text-black"
  }),
  ArrowLongRightPurpleIcon: /*#__PURE__*/_jsx(ArrowLongRightIcon, {
    className: "h-5 text-primary-800"
  }),
  ArrowTrendingUpIcon: /*#__PURE__*/_jsx(ArrowTrendingUpIcon, {
    className: "h-5"
  }),
  BellIcon: /*#__PURE__*/_jsx(BellIcon, {
    className: "h-6 w-6 text-gray-500"
  }),
  BlackBuildingOfficeIcon: /*#__PURE__*/_jsx(BuildingOfficeIcon, {
    className: "h-5 text-gray-900"
  }),
  BoltIcon: /*#__PURE__*/_jsx(BoltIcon, {
    className: "h-4"
  }),
  BookOpenIcon: /*#__PURE__*/_jsx(BookOpenIcon, {
    className: "h-5"
  }),
  BookmarkIcon: /*#__PURE__*/_jsx(BookmarkIcon, {
    className: "h-6"
  }),
  BriefcaseIcon: /*#__PURE__*/_jsx(BriefcaseIcon, {
    className: "h-6"
  }),
  BriefcasePurple800Icon: /*#__PURE__*/_jsx(BriefcaseIcon, {
    className: "h-6 w-6 text-primary-800"
  }),
  BriefcasePurpleIcon: /*#__PURE__*/_jsx(BriefcaseIcon, {
    className: "h-6 w-6"
  }),
  BuildingOfficeBlackIcon: /*#__PURE__*/_jsx(BuildingOfficeIcon, {
    className: "h-5 w-5 text-gray-900"
  }),
  BuildingOfficeGrayIcon: /*#__PURE__*/_jsx(BuildingOfficeIcon, {
    className: "h-5 text-gray-500"
  }),
  BuildingOfficeIcon: /*#__PURE__*/_jsx(BuildingOfficeIcon, {
    className: "h-6 w-6 text-primary-800"
  }),
  BuildingOfficePurpleIcon: /*#__PURE__*/_jsx(BuildingOfficeIcon, {
    className: "h-5 text-primary-800"
  }),
  BuildingOfficeWhiteIcon: /*#__PURE__*/_jsx(BuildingOfficeIcon, {
    className: "h-5 text-white"
  }),
  BulbIcon: /*#__PURE__*/_jsx(BulbIcon, {}),
  ChatBubbleLeftRightIcon: /*#__PURE__*/_jsx(ChatBubbleLeftRightIcon, {
    className: "h-6 w-6 text-primary-500"
  }),
  ChatBubbleOvalLeftEllipsisIcon: /*#__PURE__*/_jsx(ChatBubbleOvalLeftEllipsisIcon, {
    className: "h-5"
  }),
  ClockIcon: /*#__PURE__*/_jsx(ClockIcon, {
    className: "h-5"
  }),
  ClockPurpleIcon: /*#__PURE__*/_jsx(ClockIcon, {
    className: "h-5 text-primary-800"
  }),
  ClipboardDocumentCheckGreenIcon: /*#__PURE__*/_jsx(ClipboardDocumentCheckIcon, {
    className: "h-6 w-6 text-green-500"
  }),
  ClipboardDocumentCheckPurpleIcon: /*#__PURE__*/_jsx(ClipboardDocumentCheckIcon, {
    className: "h-6 w-6 text-primary-800"
  }),
  ClipboardDocumentIcon: /*#__PURE__*/_jsx(ClipboardDocumentIcon, {
    className: "h-6 w-6 text-primary-800"
  }),
  ClipboardDocumentListIcon: /*#__PURE__*/_jsx(ClipboardDocumentListIcon, {
    className: "h-5"
  }),
  ClipboardIcon: /*#__PURE__*/_jsx(ClipboardIcon, {
    className: "h-5"
  }),
  CopyIcon: /*#__PURE__*/_jsx(CopyIcon, {}),
  DocumentTextIcon: /*#__PURE__*/_jsx(DocumentTextIcon, {
    className: "h-5"
  }),
  ExclamationCircleIcon: /*#__PURE__*/_jsx(ExclamationCircleIcon, {
    className: "h-6 w-6 text-primary-800"
  }),
  GlobeEuropeAfricaIcon: /*#__PURE__*/_jsx(GlobeEuropeAfricaIcon, {
    className: "h-5 w-5 text-gray-900"
  }),
  HandRaiseRedIcon: /*#__PURE__*/_jsx(HandRaisedIcon, {
    className: "h-4 w-4 text-red-500"
  }),
  HandThumbUpIcon: /*#__PURE__*/_jsx(HandThumbUpIcon, {
    className: "h-5"
  }),
  HeartIcon: /*#__PURE__*/_jsx(HeartIcon, {
    className: "h-6 w-6 text-primary-800"
  }),
  HomeIcon: /*#__PURE__*/_jsx(HomeIcon, {
    className: "h-6 w-6 text-gray-600"
  }),
  HomeIconGray: /*#__PURE__*/_jsx(HomeIcon, {
    className: "h-5 w-5 text-gray-600"
  }),
  HouseCheckIcon: /*#__PURE__*/_jsx(HouseCheckIcon, {}),
  InformationCircleIcon: /*#__PURE__*/_jsx(InformationCircleIcon, {
    className: "h-6"
  }),
  LockClosedIcon: /*#__PURE__*/_jsx(LockClosedIcon, {
    className: "h-6 w-6 text-primary-500"
  }),
  LocationMarkIcon: /*#__PURE__*/_jsx(LocationMarkIcon, {}),
  MagnifyingGlassIcon: /*#__PURE__*/_jsx(MagnifyingGlassIcon, {
    className: "h-5 w-5 text-gray-900"
  }),
  MagnifyingGlassPurpleIcon: /*#__PURE__*/_jsx(MagnifyingGlassIcon, {
    className: "h-5 w-5 text-primary-800"
  }),
  MapIcon: /*#__PURE__*/_jsx("img", {
    src: getAssetSrc('/utils-assets/map-icon.svg'),
    className: "h-6",
    alt: ""
  }),
  MapPinIcon: /*#__PURE__*/_jsx(MapPinIcon, {
    className: "h-5 text-black"
  }),
  MapPinIconGray: /*#__PURE__*/_jsx(MapPinIcon, {
    className: "h-5 text-gray-500"
  }),
  MapPinIconPurple: /*#__PURE__*/_jsx(MapPinIcon, {
    className: "h-5 w-5 text-primary-800"
  }),
  NOfficeBuildingIcon: /*#__PURE__*/_jsx(NOfficeBuildingIcon, {}),
  NoLocationMarkerIcon: /*#__PURE__*/_jsx(NoLocationMarkerIcon, {}),
  PaperClipIcon: /*#__PURE__*/_jsx(ClipIcon, {}),
  PrivateModeProtectionCircleIcon: /*#__PURE__*/_jsx(PrivateModeProtectionCircleIcon, {}),
  PrivateModeProtectionIcon: /*#__PURE__*/_jsx(PrivateModeProtectionIcon, {}),
  PrivateModeProtectionPurpleIcon: /*#__PURE__*/_jsx(PrivateModeProtectionIcon, {
    stroke: "#693EB5"
  }),
  RedBuildingOfficeIcon: /*#__PURE__*/_jsx(BuildingOfficeIcon, {
    className: "h-6 w-6 text-primary-800"
  }),
  RestartIcon: /*#__PURE__*/_jsx(RestartIcon, {}),
  ShieldCheckIcon: /*#__PURE__*/_jsx(ShieldCheckIcon, {
    className: "h-6 w-6 text-primary-500"
  }),
  SpoonPlateIcon: /*#__PURE__*/_jsx("img", {
    src: getAssetSrc('/utils-assets/spoon-plate.svg'),
    className: "h-7",
    alt: ""
  }),
  UserGroupIcon: /*#__PURE__*/_jsx(UserGroupIcon, {
    className: "h-6 text-gray-600"
  }),
  UserGroupPurpleIcon: /*#__PURE__*/_jsx(UserGroupIcon, {
    className: "h-6 text-primary-800"
  }),
  UserPurpleIcon: /*#__PURE__*/_jsx(UserIcon, {
    className: "h-5 text-primary-800"
  }),
  InformationCircleBlackIcon: /*#__PURE__*/_jsx(InformationCircleIcon, {
    className: "h-6 text-gray-900"
  }),
  UsersIconOrange: /*#__PURE__*/_jsx(UsersIcon, {
    className: "h-6 w-6 text-orange"
  }),
  BuildingOffice2Icon: /*#__PURE__*/_jsx(BuildingOffice2Icon, {
    className: "h-4 w-4 text-neutral-200"
  }),
  PhoneIcon: /*#__PURE__*/_jsx(PhoneIcon, {
    className: "h-4 w-4 text-neutral-200 "
  }),
  EnvelopeIcon: /*#__PURE__*/_jsx(EnvelopeIcon, {
    className: "h-4 w-4 text-neutral-200"
  }),
  MapPinIconNeutral: /*#__PURE__*/_jsx(MapPinIcon, {
    className: "h-4 w-4 text-neutral-200"
  }),
  InformationCircleSolidBlackIcon: /*#__PURE__*/_jsx(InformationCircleSolidIcon, {
    className: "h-5 w-5 fill-neutral-700"
  }),
  TrashIcon: /*#__PURE__*/_jsx(TrashIcon, {
    className: "h-4 w-4"
  }),
  BriefcaseIconNeutral200: /*#__PURE__*/_jsx(BriefcaseIcon, {
    className: "h-4 w-4 text-neutral-200"
  }),
  MapPinIconNeutral200: /*#__PURE__*/_jsx(MapPinIcon, {
    className: "h-4 w-4 text-neutral-200"
  }),
  DevicePhoneMobileIcon: /*#__PURE__*/_jsx(DevicePhoneMobileIcon, {
    className: "h-4 w-4"
  }),
  WorldIcon: '🌍',
  ClipboardCheckIcon: /*#__PURE__*/_jsx(ClipboardDocumentCheckIcon, {
    className: "h-6 w-6"
  }),
  UsersIconPurple: /*#__PURE__*/_jsx(UsersIcon, {
    className: "h-6 w-6 text-purple-700"
  }),
  ChartBarIcon: /*#__PURE__*/_jsx(ChartBarIcon, {
    className: "h-4 w-4 text-neutral-700"
  }),
  MapPinIconNeutral700: /*#__PURE__*/_jsx(MapPinIcon, {
    className: "h-4 w-4 text-neutral-700"
  }),
  CalendarIcon: /*#__PURE__*/_jsx(CalendarIcon, {
    className: "h-4 w-4 text-neutral-700"
  }),
  CheckCircleIconPurple: /*#__PURE__*/_jsx(CheckCircleIcon, {
    className: "h-5 w-5 text-purple-500"
  }),
  CheckCircleIconSuccess: /*#__PURE__*/_jsx(CheckCircleIconOutline, {
    className: "h-6 w-6 text-green-500"
  })
};
/**
 * A map of text sizes to Tailwind CSS classes.
 * @property {TwStyle} superSuperSuperLarge - The Tailwind CSS class for text size 5xl (48px).
 * @property {TwStyle} text-4xl - The Tailwind CSS class for text size 4xl (36px).
 * @property {TwStyle} superSuperLarge - The Tailwind CSS class for text size 3xl (30px).
 * @property {TwStyle} superLarge - The Tailwind CSS class for text size 2xl (24px).
 * @property {TwStyle} extraLarge - The Tailwind CSS class for text size xl (20px).
 * @property {TwStyle} large - The Tailwind CSS class for text size lg (18px).
 * @property {TwStyle} base - The Tailwind CSS class for text size base (16px).
 * @property {TwStyle} small - The Tailwind CSS class for text size sm (14px).
 * @property {TwStyle} xSmall - The Tailwind CSS class for text size xs (12px).
 */

export var sizeMap = {
  superSuperSuperLarge: {
    "fontSize": "3rem",
    "lineHeight": "1"
  },
  // 48
  'text-4xl': {
    "fontSize": "2.25rem",
    "lineHeight": "2.5rem"
  },
  // 36
  superSuperLarge: {
    "fontSize": "1.875rem",
    "lineHeight": "2.25rem"
  },
  // 30
  superLarge: {
    "fontSize": "1.5rem",
    "lineHeight": "2rem"
  },
  // 24
  extraLarge: {
    "fontSize": "1.125rem",
    "lineHeight": "1.75rem",
    "@media (min-width: 1024px)": {
      "fontSize": "1.25rem",
      "lineHeight": "1.75rem"
    }
  },
  //20
  large: {
    "fontSize": "1.125rem",
    "lineHeight": "1.75rem"
  },
  // 18
  base: {
    "fontSize": "1rem",
    "lineHeight": "1.5rem"
  },
  // 16px
  small: {
    "fontSize": "0.875rem",
    "lineHeight": "1.25rem"
  },
  // 14px
  xSmall: {
    "fontSize": "0.75rem",
    "lineHeight": "1rem"
  } // 12px

};
export var fontSizeMapToStandard = function fontSizeMapToStandard(size) {
  switch (size) {
    case 'superSuperSuperLarge':
      return 'display-2';

    case 'text-4xl':
      return 'h1';

    case 'superSuperLarge':
      return 'h2';

    case 'superLarge':
      return 'h3';

    case 'extraLarge':
      return 'h4';

    case 'large':
      return 'h4';

    default:
      return 'h5';
  }
};
/**
 * A map of colors to Tailwind CSS classes.
 * @property {TwStyle} black - The Tailwind CSS class for black text.
 * @property {TwStyle} gray - The Tailwind CSS class for gray text.
 * @property {TwStyle} white - The Tailwind CSS class for white text.
 * @property {TwStyle} bold-purple - The Tailwind CSS class for bold purple text.
 * @property {TwStyle} red - The Tailwind CSS class for red text.
 * @property {TwStyle} secondary - The Tailwind CSS class for secondary text.
 * @property {TwStyle} primary-50 - The Tailwind CSS class for primary-50 text.
 * @property {TwStyle} grey-900 - The Tailwind CSS class for grey-900 text.
 * @property {TwStyle} gray-600 - The Tailwind CSS class for gray-600 text.
 */

export var colorMap = {
  black: {
    "--tw-text-opacity": "1",
    "color": "rgb(17 24 39 / var(--tw-text-opacity))"
  },
  gray: {
    "--tw-text-opacity": "1",
    "color": "rgb(107 114 128 / var(--tw-text-opacity))"
  },
  white: {
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  },
  'bold-purple': {
    "--tw-text-opacity": "1",
    "color": "rgb(105 62 181 / var(--tw-text-opacity))"
  },
  red: {
    "--tw-text-opacity": "1",
    "color": "rgb(186 0 31 / var(--tw-text-opacity))"
  },
  secondary: {
    "--tw-text-opacity": "1",
    "color": "rgb(199 214 47 / var(--tw-text-opacity))"
  },
  'primary-50': {
    "--tw-text-opacity": "1",
    "color": "rgb(246 245 255 / var(--tw-text-opacity))"
  },
  'grey-900': {
    "--tw-text-opacity": "1",
    "color": "rgb(17 24 39 / var(--tw-text-opacity))"
  },
  'gray-600': {
    "--tw-text-opacity": "1",
    "color": "rgb(75 85 99 / var(--tw-text-opacity))"
  },
  'gray-500': {
    "--tw-text-opacity": "1",
    "color": "rgb(107 114 128 / var(--tw-text-opacity))"
  },
  'gray-900': {
    "--tw-text-opacity": "1",
    "color": "rgb(17 24 39 / var(--tw-text-opacity))"
  },
  'primary-700': {
    "--tw-text-opacity": "1",
    "color": "rgb(105 62 181 / var(--tw-text-opacity))"
  },
  'red-800': {
    "--tw-text-opacity": "1",
    "color": "rgb(112 0 19 / var(--tw-text-opacity))"
  },
  'gray-50': {
    "--tw-text-opacity": "1",
    "color": "rgb(249 250 251 / var(--tw-text-opacity))"
  },
  'gray-400': {
    "--tw-text-opacity": "1",
    "color": "rgb(156 163 175 / var(--tw-text-opacity))"
  },
  'neutral-200': {
    "--tw-text-opacity": "1",
    "color": "rgb(102 102 118 / var(--tw-text-opacity))"
  },
  'neutral-700': {
    "--tw-text-opacity": "1",
    "color": "rgb(28 28 51 / var(--tw-text-opacity))"
  },
  'purple-700': {
    "--tw-text-opacity": "1",
    "color": "rgb(72 36 133 / var(--tw-text-opacity))"
  },
  'orange-700': {
    "--tw-text-opacity": "1",
    "color": "rgb(158 84 0 / var(--tw-text-opacity))"
  },
  'purple-500': {
    "--tw-text-opacity": "1",
    "color": "rgb(102 51 187 / var(--tw-text-opacity))"
  },
  'neutral-100': {
    "--tw-text-opacity": "1",
    "color": "rgb(117 117 131 / var(--tw-text-opacity))"
  },
  'neutral-10': {
    "--tw-text-opacity": "1",
    "color": "rgb(250 250 250 / var(--tw-text-opacity))"
  },
  'green-700': {
    "--tw-text-opacity": "1",
    "color": "rgb(0 84 45 / var(--tw-text-opacity))"
  }
};
/**
 * A map of font weights to Tailwind CSS classes.
 * @property {TwStyle} font-bold - The Tailwind CSS class for bold text.
 * @property {TwStyle} font-medium - The Tailwind CSS class for medium text.
 * @property {TwStyle} font-normal - The Tailwind CSS class for normal text.
 * @property {TwStyle} font-light - The Tailwind CSS class for light text.
 * @property {TwStyle} font-semibold - The Tailwind CSS class for semibold text.
 * @property {TwStyle} font-extrabold - The Tailwind CSS class for extrabold text.
 */

export var fontWeightMap = {
  light: {
    "fontWeight": "300"
  },
  // 300
  normal: {
    "fontWeight": "400"
  },
  //400
  medium: {
    "fontWeight": "500"
  },
  // 500
  semibold: {
    "fontWeight": "600"
  },
  // 600
  bold: {
    "fontWeight": "700"
  },
  // 700
  extrabold: {
    "fontWeight": "800"
  } // 800

};